'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _numeral = require('numeral');

var _numeral2 = _interopRequireDefault(_numeral);

var _isNumber = require('is-number');

var _isNumber2 = _interopRequireDefault(_isNumber);

var _isString = require('is-string');

var _isString2 = _interopRequireDefault(_isString);

var _type = require('../type');

var _type2 = _interopRequireDefault(_type);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var format = function format(value) {
  return (0, _isString2.default)(value) || (0, _isNumber2.default)(value) ? (0, _numeral2.default)(value).format('0,0.00') : null;
};

var validate = function validate(value) {
  return /(?=.)^(([1-9][0-9]{0,2}(,[0-9]{3})*)|[0-9]+)?(\.[0-9]{2})?$/.test(value);
};

exports.default = (0, _type2.default)({
  type: 'string',
  format: format,
  validate: validate
});